export default {
    FILTER_CHANGE: 'SpecFilterChanged',
    APPLY_SINGLE_FILTER: 'ApplySpecFilter',
    APPLY_FILTERS: 'ApplySpecFilters',
    OPEN_FILTER: 'OpenSpecFilter',
};
